// Small UI overlay for switching elements in playground mode.
// 92 buttons in a wrapping grid. Returns a handle to update the active highlight.

const ELEMENTS = [
  "H","He","Li","Be","B","C","N","O","F","Ne",
  "Na","Mg","Al","Si","P","S","Cl","Ar","K","Ca",
  "Sc","Ti","V","Cr","Mn","Fe","Co","Ni","Cu","Zn",
  "Ga","Ge","As","Se","Br","Kr","Rb","Sr","Y","Zr",
  "Nb","Mo","Tc","Ru","Rh","Pd","Ag","Cd","In","Sn",
  "Sb","Te","I","Xe","Cs","Ba","La","Ce","Pr","Nd",
  "Pm","Sm","Eu","Gd","Tb","Dy","Ho","Er","Tm","Yb",
  "Lu","Hf","Ta","W","Re","Os","Ir","Pt","Au","Hg",
  "Tl","Pb","Bi","Po","At","Rn","Fr","Ra","Ac","Th",
  "Pa","U",
];

export interface ElementPicker {
  setActive(el: string): void;
}

export function mountElementPicker(
  initial: string,
  onPick: (el: string) => void,
): ElementPicker {
  const existing = document.getElementById("element-picker");
  if (existing) existing.remove();

  const root = document.createElement("div");
  root.id = "element-picker";
  root.style.cssText = `
    position: fixed; left: 50%; bottom: 16px; transform: translateX(-50%);
    z-index: 9000; max-width: 92vw; max-height: 28vh; overflow-y: auto;
    display: grid; grid-template-columns: repeat(auto-fill, 38px); gap: 4px;
    padding: 10px 12px;
    background: rgba(4,7,15,0.78);
    backdrop-filter: blur(14px);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 12px;
    font: 500 12px 'JetBrains Mono', monospace;
    pointer-events: auto;
    touch-action: auto;
  `;

  const buttons = new Map<string, HTMLButtonElement>();

  function paint(active: string) {
    for (const [el, btn] of buttons) {
      const on = el === active;
      btn.style.background = on ? "rgba(123,94,167,0.45)" : "rgba(255,255,255,0.04)";
      btn.style.color = on ? "#fff" : "#c8d0e0";
      btn.style.borderColor = on ? "rgba(123,94,167,0.9)" : "rgba(255,255,255,0.08)";
    }
  }

  for (const el of ELEMENTS) {
    const btn = document.createElement("button");
    btn.textContent = el;
    btn.dataset.el = el;
    btn.style.cssText = `
      width: 38px; height: 30px;
      padding: 0; cursor: pointer;
      background: rgba(255,255,255,0.04);
      color: #c8d0e0;
      border: 1px solid rgba(255,255,255,0.08);
      border-radius: 6px;
      font: inherit;
      touch-action: manipulation;
    `;
    // Use pointerdown rather than click — the stage's pointer-events config
    // can swallow synthesized click events on touch devices.
    btn.addEventListener("pointerdown", (ev) => {
      ev.stopPropagation();
      onPick(el);
    });
    buttons.set(el, btn);
    root.appendChild(btn);
  }

  paint(initial);
  document.body.appendChild(root);

  return { setActive: paint };
}
